import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="lead-modal"
export default class extends Controller {
  static targets = ["content"];

  connect() {
  }

  open(productType = "") {
    // Set the product type
    const productInput = document.getElementById("productType");
    const modalTitle = document.getElementById("modalTitle");

    if (productInput) {
      productInput.value = productType;
    }

    if (modalTitle) {
      modalTitle.textContent = productType
        ? `Request Information - ${productType}`
        : "Request Information";
    }

    // Show modal
    this.element.classList.remove("hidden");
    this.element.classList.add("flex");

    // Prevent body scroll
    document.body.style.overflow = "hidden";

    // Focus on first input
    setTimeout(() => {
      const firstInput = this.element.querySelector('input[type="text"]');
      if (firstInput) {
        firstInput.focus();
      }
    }, 100);
  }

  close() {
    this.element.classList.add("hidden");
    this.element.classList.remove("flex");

    // Restore body scroll
    document.body.style.overflow = "auto";

    // Reset form
    const form = document.getElementById("leadForm");
    if (form) {
      form.reset();
    }
  }

  // Close modal when clicking outside
  handleBackdropClick(event) {
    if (event.target === this.element) {
      this.close();
    }
  }

  // Handle form submission
  submitForm(event) {
    event.preventDefault();

    const form = event.target;
    const submitBtn = document.getElementById("submitBtn");
    const formData = new FormData(form);

    // Disable submit button
    submitBtn.disabled = true;
    submitBtn.textContent = "Sending...";

    fetch("/leads", {
      method: "POST",
      body: formData,
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
          .content,
        Accept: "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          // Show success message
          this.showNotification(data.message, "success");
          this.close();
        } else {
          // Show error messages
          const errorMessage = data.errors
            ? data.errors.join(", ")
            : "Something went wrong";
          this.showNotification(errorMessage, "error");
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        this.showNotification("Network error. Please try again.", "error");
      })
      .finally(() => {
        // Re-enable submit button
        submitBtn.disabled = false;
        submitBtn.textContent = "Send Request";
      });
  }

  showNotification(message, type = "success") {
    // Create notification element
    const notification = document.createElement("div");
    notification.className = `fixed top-4 right-4 z-50 p-4 rounded-lg shadow-lg max-w-sm transform transition-all duration-300 ${
      type === "success"
        ? "bg-green-50 border border-green-200 text-green-800"
        : "bg-red-50 border border-red-200 text-red-800"
    }`;

    notification.innerHTML = `
            <div class="flex items-center">
                <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    ${
                      type === "success"
                        ? '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>'
                        : '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>'
                    }
                </svg>
                <span>${message}</span>
            </div>
        `;

    document.body.appendChild(notification);

    // Auto-remove after 5 seconds
    setTimeout(() => {
      notification.remove();
    }, 5000);
  }
}
